import { getSlugValue } from 'utilities';

export const SCHEDULE_OF_INVESTMENTS_SPREADSHEET_COLUMN_KEY_PREFIX = 'security';
export const SCHEDULE_OF_INVESTMENTS_SPREADSHEET_COLUMN_NAME = 'Column';
export const SCHEDULE_OF_INVESTMENTS_SPREADSHEET_COLUMN_NAME_PLURAL = 'Columns';
export const SCHEDULE_OF_INVESTMENTS_SPREADSHEET_TITLE = 'Schedule of Investments';
export const SCHEDULE_OF_INVESTMENTS_SPREADSHEET_SLUG = getSlugValue(SCHEDULE_OF_INVESTMENTS_SPREADSHEET_TITLE);
export const SCHEDULE_OF_INVESTMENTS_SPREADSHEET_TABLE = `${SCHEDULE_OF_INVESTMENTS_SPREADSHEET_SLUG}-table`;
export const SCHEDULE_OF_INVESTMENTS_CONTAINER_CLASSNAME = `${SCHEDULE_OF_INVESTMENTS_SPREADSHEET_SLUG}-container`;
